<template>
	<reportFormWrap
		ref="reportFormWrap"
		:reportid="reportid"
		:orderMenu="orderMenu"
		:settingCols="settingCols"
		:getFiltersParams="getFiltersParams"
		:reportFormUrl="reportFormUrl"
		:zipFlag="zipFlag"
		:pagingFlag="pagingFlag"
		:exportByServerFlag="exportByServerFlag"
		:reportName="reportName"
		@clearSearchClick='clearSearchClick'
		:getCustomThroughParams="getCustomThroughParams">
		<FiltersBox slot="filters" ref="filters" @inputEnter='inputEnter'></FiltersBox>
	</reportFormWrap>
</template>

<script>
import { cols } from '@/js/reportform/transactionNew.js'
import { orderMenu } from '@/js/reportform/reportformCommon.js'
import reportFormWrap from '@/components/reportform/common/ReportFormWrapBest.vue'
import FiltersBox from '@/components/reportform/transactionNew/FiltersBox.vue'
export default {
	name: 'transactionNew',
	components: {
		reportFormWrap,
		FiltersBox
	},
	data () {
		return {
			zipFlag: false, // 是否压缩
			pagingFlag: false, // 是否真分页
			exportByServerFlag: false, // 是否后端导出
			reportid: 'PAY_ZFLS_000008',
			settingCols: cols,
			reportFormUrl: `${this.$fxBaseApi.urlReport}/report/getPayDetailReportNew`,
			orderMenu: orderMenu,
			reportName: 'transactionNew'
		}
	},
	mounted () {
		this.$refs.reportFormWrap.initReportForm()
	},
	methods: {
		clearSearchClick () {
			this.$refs.filters.clearSearch()
		},
		inputEnter () {
			return this.$refs.reportFormWrap.searchHandler()
		},
		getFiltersParams () {
			return this.$refs.filters.getFiltersParams()
		},
		getCustomThroughParams () {
			return this.$refs.filters.getFiltersDate()
		}
	}
}
</script>
<style lang="stylus" scoped>
</style>
